<template>
  <div :class="$style.page">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="域名转出识道网络" name="first">
        <template v-if="activeName === 'first'">
          <OutNine />
        </template>
      </el-tab-pane>
      <el-tab-pane label="域名转出记录" name="second">
        <template v-if="activeName === 'second'">
          <OutRecord />
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import OutNine from "./domain-out/OutNine.vue";
import OutRecord from "./domain-out/OutRecord.vue";

export default {
  name: "DomainOut",
  components: {
    OutNine,
    OutRecord,
  },
  data() {
    return {
      activeName: "first",
    };
  },
  watch: {
    $route({ query }) {
      this.activeName = query.activeName || "first";
    },
  },
  methods: {
    handleClick() {
      const query =
        this.activeName === "first" ? {} : { activeName: this.activeName };
      this.$router.push({ path: "/user/domain-out", query });
    },
  },
  created() {
    const { query } = this.$route;
    this.activeName = query.activeName || "first";
  },
};
</script>

<style lang="scss" module scoped>
.page {

  :global {
    ::v-deep .el-tabs {
      .el-tabs__content {
        min-height: 300px;
      }
    }
  }
}
</style>
